import { Injectable, inject } from '@angular/core';
import { retry, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IEnrollmentLink } from '../../interfaces/enrollment/enrollment-link';
import { IAppleReenrollmentInfo } from '../../interfaces/account/apple-reenrollment-info';
import { IProcessOutputResult } from '../../interfaces/process-output-result';
import { SharedService } from '../shared.service';

@Injectable({
  providedIn: 'root'
})
export class EnrollmentService {

  private readonly sharedService = inject(SharedService);
  private readonly http = inject(HttpClient);

  private readonly appleRecoveryUrl: string = '/ui-pages/aw-recov/{serialNumber}';
  private readonly nonmobileQRCodeUrl: string = '/ui-pages/non-mobile/qr';
  private readonly emailInvitationUrl: string = '/ui-pages/non-mobile/send-email';
  private readonly smsInvitationUrl: string = '/ui-pages/non-mobile/send-sms';
  private readonly enrollmentButtonsUrl: string = '/ui-pages/sm-link/enroll-buttons';

  private readonly baseHeaders = new HttpHeaders()
    .set("request-origin", "csr-portal");

  constructor() { }

  public getAppleReenrollmentInfo(region: string, serialNumber: string, sessionId?: string): Observable<IAppleReenrollmentInfo> {
    let url = this.sharedService.getBaseUrlByRegion(region) + this.appleRecoveryUrl
      .replace('{serialNumber}', serialNumber);
      let headers = new HttpHeaders()
      .set("request-origin", "csr-portal")
      .set('session-id', sessionId? sessionId : '')
      .set('source', 'aw-recov');       
    return this.http.get<IAppleReenrollmentInfo>(url, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  public getQRCode(region: string, sessionId: string, source?: string): Observable<any> {
    let url = this.sharedService.getBaseUrlByRegion(region) + this.nonmobileQRCodeUrl;
      let headers = new HttpHeaders()
      .set("request-origin", "csr-portal")
      .set('session-id', sessionId);
      // .set('source', source ? source : '');      
    return this.http.get<any>(url, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  public sendSMSInvitation(region: string, sessionId: string,  phoneNumber: string): Observable<IProcessOutputResult> {
    let headers = new HttpHeaders()
    .set("request-origin", "csr-portal")
    .set('session-id', sessionId);      
    let url = this.sharedService.getBaseUrlByRegion(region) + this.smsInvitationUrl;
    return this.http.post<IProcessOutputResult>(url, phoneNumber, {headers: headers, responseType: 'json'}).pipe(
      catchError(this.sharedService.handleError)
    );
  }

  public sendEmailInvitation(region: string, sessionId: string,  emailAddress: string): Observable<IProcessOutputResult> {
    let headers = new HttpHeaders()
    .set("request-origin", "csr-portal")
    .set('session-id', sessionId);      
    let url = this.sharedService.getBaseUrlByRegion(region) + this.emailInvitationUrl;
    return this.http.post<IProcessOutputResult>(url, `"${emailAddress}"`, {headers: headers, responseType: 'json'}).pipe(
      catchError(this.sharedService.handleError)
    );
  }

  public getEnrollmentButtons(region: string, sessionId: string, source?: string): Observable<IEnrollmentLink[]> {
    let url = this.sharedService.getBaseUrlByRegion(region) + this.enrollmentButtonsUrl;
      let headers = new HttpHeaders()
      .set("request-origin", "csr-portal")
      .set('session-id', sessionId);
      // .set('source', source ? source : '');    
      console.log('url', url);
    return this.http.get<IEnrollmentLink[]>(url, {headers: headers, responseType: 'json'})
    .pipe(
      catchError(this.sharedService.handleError)
    )
  }

  

}
